import { render, staticRenderFns } from "./Yihao.vue?vue&type=template&id=4b6c5b16&scoped=true"
import script from "./Yihao.vue?vue&type=script&lang=js"
export * from "./Yihao.vue?vue&type=script&lang=js"
import style0 from "./Yihao.vue?vue&type=style&index=0&id=4b6c5b16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c5b16",
  null
  
)

export default component.exports